import {
    useInfiniteQuery,
    useMutation,
    useQueryClient
} from '@tanstack/react-query';
import {
    deleteRecord,
    fetchRecords
} from '../services/SubscriptionsService';
import {useState} from 'react';
import {useUserAccount} from '../../../../hooks/useUserAccount';

export const useSubscriptions = () => {
    const queryClient = useQueryClient();
    const [keyword, setKeyword] = useState('');
    const [limit] = useState(10);
    const [selection] = useState<Record<string, boolean>>({});
    const {userAccount} = useUserAccount();

    const sort = {
        column: 'created',
        direction: 'desc' as const
    };

    // INFINITE QUERY
    const subscriptionsQuery = useInfiniteQuery({
        queryKey: ['subscriptions', keyword, limit, sort.column, sort.direction, userAccount?.customerId],
        queryFn: async ({pageParam}: { pageParam: string | null }) => {
            return fetchRecords({
                limit,
                nextToken: pageParam ?? undefined
            });
        },
        getNextPageParam: (lastPage) => {
            if (!lastPage || !lastPage.nextToken) return undefined;
            return lastPage.nextToken;
        },
        initialPageParam: null,
        enabled: !!userAccount?.customerId
    });

    // DELETE MUTATION
    const deleteMutation = useMutation({
                                           mutationFn: async (ids: string[]) => {
                                               const promises = ids.map(id => deleteRecord(id));
                                               return Promise.all(promises);
                                           },
                                           onSuccess: () => {
                                               queryClient.invalidateQueries({queryKey: ['subscriptions']});
                                           }
                                       });

    const fetchRecordsAction = () => {
        // Invalidate and refetch to get latest data
        queryClient.invalidateQueries({queryKey: ['subscriptions']});
    };

    const deleteRecords = (ids?: string[]) => {
        const selectedIds = ids || Object.keys(selection);
        if (selectedIds.length > 0) {
            deleteMutation.mutate(selectedIds);
        }
    };

    const handleFilterByKeyword = (newKeyword: string) => {
        setKeyword(newKeyword);
    };

    const allItems = subscriptionsQuery.data?.pages?.flatMap(page =>
                                                                 page?.items || []
    ) || [];

    return {
        items: allItems,
        visibleItems: allItems,
        loading: subscriptionsQuery.isLoading,
        keyword,
        visibleCount: allItems.length,
        totalCount: allItems.length,
        nextToken: subscriptionsQuery.hasNextPage ? 'has-more' : null,
        fetchRecords: fetchRecordsAction,
        refetch: subscriptionsQuery.refetch,
        deleteRecords,
        handleFilterByKeyword,
        deleteMutation
    };
};




